import { render } from "./videoResourcesDashboard.vue?vue&type=template&id=0d07ceb0&scoped=true"
import script from "./videoResourcesDashboard.vue?vue&type=script&lang=js"
export * from "./videoResourcesDashboard.vue?vue&type=script&lang=js"

import "./videoResourcesDashboard.vue?vue&type=style&index=0&id=0d07ceb0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d07ceb0"]])

export default __exports__